module.exports = __webpack_public_path__ + "static/media/silver.f587b421.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/images/silver.png
// module id = 1944
// module chunks = 0